import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { findNameBySlug } from '../utils/name';
import { NameData } from '../types';
import NameDisplay from '../components/NameDisplay';
import Layout from '../components/Layout';

export default function NamePage() {
  const { nameSlug } = useParams<{ nameSlug: string }>();
  const [nameData, setNameData] = useState<NameData | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function loadNameData() {
      if (nameSlug) {
        const data = await findNameBySlug(nameSlug);
        setNameData(data);
        setLoading(false);
      }
    }
    loadNameData();
  }, [nameSlug]);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!nameData) {
    return <div>Name not found</div>;
  }

  return (
    <Layout>
      <Helmet>
        <title>{`${nameData.name} - Name Meaning and Origin`}</title>
        <meta name="description" content={nameData.nepali_meaning} />
        <meta property="og:title" content={`${nameData.name} - Name Meaning`} />
        <meta property="og:description" content={nameData.nepali_meaning} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={window.location.href} />
        <meta property="og:image" content={`${window.location.origin}/api/og-image/${nameSlug}`} />
      </Helmet>

      <NameDisplay nameData={nameData} />
    </Layout>
  );
}